import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import {
  addCallForActionError,
  addCallForActionSuccess,
  editCallForActionError,
  editCallForActionSuccess,
  getCallForActionError,
  getCallForActionSuccess,
} from './actions'
import {
  ADD_CALL_FOR_ACTION_ASYNC,
  EDIT_CALL_FOR_ACTION_ASYNC,
  GET_CALL_FOR_ACTION_ASYNC,
} from './constants'

const getCallForActionBody = (state, action) => ({
  name: state.awarenessCenter.callForActionForm.callForAction.name,
  page_title: state.awarenessCenter.callForActionForm.callForAction.title,
  is_public: state.awarenessCenter.callForActionForm.callForAction.isPublic,
  content: state.awarenessCenter.callForActionForm.callForAction.content,
  force_save: action.payload.forceSave || false,
})

const editCallForActionEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(EDIT_CALL_FOR_ACTION_ASYNC.INITIATE).mergeMap((action) =>
    api.awarenessCenter
      .editCallForAction(
        action.payload.id,
        getCallForActionBody(store.getState(), action),
        store.getState().partnerOptions.selectedCompany?.value,
        !!store.getState().app.data.partner
      )
      .map((response) => editCallForActionSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(editCallForActionError, error, [400])))
      .takeUntil(action$.ofType(EDIT_CALL_FOR_ACTION_ASYNC.CANCEL))
  )

const addCallForActionEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(ADD_CALL_FOR_ACTION_ASYNC.INITIATE).mergeMap((action) =>
    api.awarenessCenter
      .addCallForAction(
        getCallForActionBody(store.getState(), action),
        store.getState().partnerOptions.selectedCompany?.value,
        !!store.getState().app.data.partner
      )
      .map(() => addCallForActionSuccess())
      .catch((error) => Observable.of(epicsErrorHandler(addCallForActionError, error, [400])))
      .takeUntil(action$.ofType(ADD_CALL_FOR_ACTION_ASYNC.CANCEL))
  )

const getCallForActionEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(GET_CALL_FOR_ACTION_ASYNC.INITIATE).mergeMap((action) =>
    api.awarenessCenter
      .getCallForAction(
        action.payload.id,
        store.getState().partnerOptions.selectedCompany?.value,
        !!store.getState().app.data.partner
      )
      .map((response) => getCallForActionSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(getCallForActionError, error)))
      .takeUntil(action$.ofType(GET_CALL_FOR_ACTION_ASYNC.CANCEL))
  )

export default combineEpics(getCallForActionEpic, addCallForActionEpic, editCallForActionEpic)
